
import { useTheme } from '@mui/material/styles';

export const AccessDenied = ({ pageName = 'this', customStyle = {} }) => {
  const theme = useTheme();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        fontSize: 28,
        // width: '100%',
        color: theme.palette.primary.main,
        background: theme.palette.background.default,
        fontWeight: 600,
        letterSpacing: 1,
        borderRadius: 12,
        margin: 32,
        ...customStyle,
        // boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
      }}
    >
      Access Denied<br />
      <span style={{ fontSize: 16, fontWeight: 400, marginTop: 12, color: theme.palette.text.secondary }}>
        You do not have permission to view {pageName} page.
      </span>
    </div>
  );
};